import { AnsweringClient } from "../clients/answeringClient";

export interface AllowFeedbackResponse {
  allowFeedback: boolean;
  defaultFeedback: boolean;
  applicationAllowFeedback: boolean;
}

export interface FinishScreenControllerDelegate {
  applicationShouldLogout(): void;
  genericError(message?: string): void;
  feedbackInactive(message: string): void;
  didGetAllowFeedback(data: AllowFeedbackResponse): void;
  didGetAssignmentToken(token: string): void;
  didClickSeeResults(assignmentId: number): void;
}

export class FinishScreenController {
  constructor (
    private delegate: FinishScreenControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async getAllowFeedback(accessToken: string, applicationId: number) {
    try {
      const response = await this.answeringClient.getAllowFeedback(accessToken, applicationId);
      this.delegate.didGetAllowFeedback(response.data);
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAllowFeedback(newTokens.accessToken, applicationId);
        return;
      }
      this.delegate.genericError((error as any)?.response?.data?.message);
    }
  }


  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }

  public async getAssignmentFeedbackToken(accessToken: string, assignmentId: number) {
    try {
      const response = await this.answeringClient.getAssignmentFeedbackToken(accessToken, assignmentId);
      const token = response.data.token;
      this.delegate.didGetAssignmentToken(token);
    } catch (error: any) {
      //401 token expirado ou invalido, tentar refresh - aguardando mudanca no backend
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAssignmentFeedbackToken(newTokens.accessToken, assignmentId);
        return;
      }
      if (error?.response?.status === 422) {
        this.delegate.feedbackInactive("O acesso à devolutiva está inativo nesta aplicação.");
        return;
      }
      this.delegate.genericError(error?.response?.data?.message);
    }
  }

  didClickSeeResults(assignmentId: number) {
    this.delegate.didClickSeeResults(assignmentId);
  }

}